import React, { useRef, useState, useEffect } from 'react';
import { Button } from '../ui/Button';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

export const ContactPhotoCapture = ({ file, onFileChange }) => {
  const fileInputRef = useRef(null);
  const [preview, setPreview] = useState(null);

  // Clean up object URL to prevent memory leaks
  useEffect(() => {
    return () => {
      if (preview) URL.revokeObjectURL(preview);
    };
  }, [preview]);

  const handleFileChange = (e) => {
    const selected = e.target.files[0];
    if (selected) {
       if (selected.size > 5 * 1024 * 1024) {
           alert('Image must be less than 5MB.');
           return;
       }
       onFileChange(selected);
       setPreview(URL.createObjectURL(selected));
    }
  };

  const handleClear = () => {
    onFileChange(null);
    if (preview) URL.revokeObjectURL(preview);
    setPreview(null);
    if (fileInputRef.current) fileInputRef.current.value = '';
  };

  return (
     <div className="bg-slate-50 p-4 rounded-xl border border-slate-100 flex items-center justify-between mt-5">
        <div className="flex items-center gap-4">
           <div className="w-14 h-14 rounded-full bg-white flex items-center justify-center overflow-hidden border border-slate-200 shrink-0">
              {preview ? (
                 <img src={preview} className="w-full h-full object-cover" alt="Preview" />
              ) : (
                 <SafeIcon icon={FiIcons.FiCamera} className="text-xl text-slate-400" />
              )}
           </div>
           <div>
              <p className="text-sm font-bold text-slate-900">Add a Photo <span className="font-normal text-slate-500">(Optional)</span></p>
              <p className="text-xs text-slate-500 mt-0.5">Help them remember you.</p>
           </div>
        </div>
        <div>
           {preview ? (
              <Button type="button" variant="ghost" size="sm" onClick={handleClear} className="text-red-500 hover:text-red-700 hover:bg-red-50">Remove</Button>
           ) : (
              <Button type="button" variant="secondary" size="sm" onClick={() => fileInputRef.current?.click()}>Choose</Button>
           )}
           <input 
              type="file" 
              accept="image/png, image/jpeg, image/webp" 
              capture="user" 
              ref={fileInputRef} 
              onChange={handleFileChange} 
              className="hidden" 
           />
        </div>
     </div>
  );
};